import { FNOL } from '../../src/components'
import Footers from '../../src/components/Footer'
import Header from '../../src/components/Header'

export default function FNOLForm() {
  return (
    <>
      <Header />
        <div className="cure-inner-container">
          <FNOL />
        </div>
      <Footers />
    </>
  )
}
